// app_client/src/componenets/modals/PasswordModal.jsx
import React, { useState } from 'react';
import { Eye, EyeOff, KeyRound, RefreshCw, X } from 'lucide-react';

const generateSecurePassword = () => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()-_=+[]{};:,.?';
  const all = upper + lower + numbers + symbols;
  const length = 14;

  const requiredChars = [
    upper[Math.floor(Math.random() * upper.length)],
    lower[Math.floor(Math.random() * lower.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
    symbols[Math.floor(Math.random() * symbols.length)]
  ];

  const rest = Array.from({ length: length - requiredChars.length }, () => (
    all[Math.floor(Math.random() * all.length)]
  ));

  return [...requiredChars, ...rest]
    .sort(() => Math.random() - 0.5)
    .join('');
};

const PasswordModal = ({ isOpen, onClose, onSave, user }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleGeneratePassword = () => {
    const generatedPassword = generateSecurePassword();
    setPassword(generatedPassword);
    setConfirmPassword(generatedPassword);
    setShowPassword(true);
    setShowConfirmPassword(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      alert('Şifre ve şifre tekrarı eşleşmiyor.');
      return;
    }

    onSave(password, user?._id);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-200">
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-red-50/50">
          <div className="flex items-center gap-2 text-red-600">
            <KeyRound size={20} />
            <h2 className="text-lg font-bold">Şifre Değiştir</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors"><X size={20} /></button>
        </div>

        <div className="p-6">
          <p className="text-sm text-slate-500 mb-4">
            <span className="font-bold text-slate-700">{user?.name}</span> için yeni bir şifre belirleyin.
          </p>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <div className="mb-2 flex items-center justify-between gap-3">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">
                  Yeni Şifre
                </label>
                <button
                  type="button"
                  onClick={handleGeneratePassword}
                  className="inline-flex items-center gap-1.5 rounded-xl bg-amber-50 px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-amber-700 transition-colors hover:bg-amber-100"
                >
                  <RefreshCw size={12} /> Şifre Üret
                </button>
              </div>
              <div className="relative">
                <input 
                  type={showPassword ? 'text' : 'password'}
                  required
                  minLength={12}
                  placeholder="Yeni Şifre"
                  className="w-full rounded-xl border border-slate-200 bg-slate-50 p-3 pr-12 font-mono font-bold outline-none transition-all focus:ring-2 focus:ring-red-500"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((current) => !current)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-white hover:text-slate-700"
                  aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div>
              <label className="mb-2 block text-[10px] font-black uppercase tracking-widest text-slate-400">
                Şifre Tekrarı
              </label>
              <div className="relative">
                <input 
                  type={showConfirmPassword ? 'text' : 'password'}
                  required
                  minLength={12}
                  placeholder="Şifre Tekrarı"
                  className="w-full rounded-xl border border-slate-200 bg-slate-50 p-3 pr-12 font-mono font-bold outline-none transition-all focus:ring-2 focus:ring-red-500"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword((current) => !current)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-white hover:text-slate-700"
                  aria-label={showConfirmPassword ? 'Şifre tekrarını gizle' : 'Şifre tekrarını göster'}
                >
                  {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            
            <div className="flex gap-3 pt-2">
              <button type="button" onClick={onClose} className="flex-1 p-3 bg-slate-100 text-slate-600 font-bold rounded-xl">Vazgeç</button>
              <button type="submit" className="flex-1 p-3 bg-red-600 text-white font-bold rounded-xl shadow-lg shadow-red-500/30">Şifreyi Güncelle</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
